import { LocalDateTime as LocalDateTime } from '@js-joda/core';
import {
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DateTimeFormatException2onfeknbywaob as DateTimeFormatException } from './Exceptions.mjs';
import {
  isJodaDateTimeParseException1w7urgwwcr7j6 as isJodaDateTimeParseException,
  isJodaDateTimeException2l3lhdyy3jadv as isJodaDateTimeException,
} from './JSJodaExceptions.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_instance6qbrtyiwm67y as Companion_instance,
  get_ISO_DATETIME2pryl9hy3c2kg as get_ISO_DATETIME,
} from './format/LocalDateTimeFormat.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toMonth3hgp8a1svgsmg as toMonth } from './Month.mjs';
import { LocalDate31mqn6zavbpi8 as LocalDate } from './LocalDate.mjs';
import { LocalTime22kisvxz6f9p4 as LocalTime } from './LocalTime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { LocalDateTimeIso8601Serializer_getInstance2em1n1hwy5urt as LocalDateTimeIso8601Serializer_getInstance } from './serializers/LocalDateTimeSerializers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function getIsoDateTimeFormat() {
  return Formats_getInstance().w1o_1;
}
function format(_this__u8e3s4, format) {
  return format.x1o(_this__u8e3s4);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.q25_1 = LocalDateTime_0().d27(LocalDateTime.MIN);
        this.r25_1 = LocalDateTime_0().d27(LocalDateTime.MAX);
      }
      e27(input, format) {
        var tmp;
        if (format === Formats_getInstance().w1o_1) {
          var tmp_0;
          try {
            // Inline function 'kotlinx.datetime.jsTry' call
            // Inline function 'kotlin.let' call
            var p0 = LocalDateTime.parse(toString(input));
            tmp_0 = LocalDateTime_0().d27(p0);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Error) {
              var e = $p;
              if (isJodaDateTimeParseException(e))
                throw DateTimeFormatException().a1o(e);
              throw e;
            } else {
              throw $p;
            }
          }
          tmp = tmp_0;
        } else {
          tmp = format.ev(input);
        }
        return tmp;
      }
      s25(input, format, $super) {
        format = format === VOID ? getIsoDateTimeFormat() : format;
        return $super === VOID ? this.e27(input, format) : $super.e27.call(this, input, format);
      }
      f27(builder) {
        return Companion_instance.l1w(builder);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
var FormatsClass;
function Formats() {
  if (FormatsClass === VOID) {
    class $ {
      constructor() {
        Formats_instance = this;
        this.w1o_1 = get_ISO_DATETIME();
      }
    }
    initMetadataForObject($, 'Formats');
    FormatsClass = $;
  }
  return FormatsClass;
}
var Formats_instance;
function Formats_getInstance() {
  if (Formats_instance === VOID)
    new (Formats())();
  return Formats_instance;
}
var LocalDateTimeClass;
function LocalDateTime_0() {
  if (LocalDateTimeClass === VOID) {
    class $ {
      static d27(value) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.u1o_1 = value;
        return $this;
      }
      static v1o(year, monthNumber, dayOfMonth, hour, minute, second, nanosecond) {
        Companion_getInstance();
        second = second === VOID ? 0 : second;
        nanosecond = nanosecond === VOID ? 0 : nanosecond;
        var tmp;
        try {
          // Inline function 'kotlinx.datetime.jsTry' call
          tmp = LocalDateTime.of(year, monthNumber, dayOfMonth, hour, minute, second, nanosecond);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            if (isJodaDateTimeException(e))
              throw IllegalArgumentException().be(e);
            throw e;
          } else {
            throw $p;
          }
        }
        return this.d27(tmp);
      }
      static u1w(date, time) {
        Companion_getInstance();
        // Inline function 'kotlinx.datetime.jsTry' call
        var tmp$ret$1 = LocalDateTime.of(date.q1o_1, time.y1o_1);
        return this.d27(tmp$ret$1);
      }
      r1o() {
        return this.u1o_1.year();
      }
      g27() {
        return toMonth(this.u1o_1.month());
      }
      t1o() {
        return this.u1o_1.dayOfMonth();
      }
      z1o() {
        return this.u1o_1.hour();
      }
      a1p() {
        return this.u1o_1.minute();
      }
      v1w() {
        return LocalDate().z26(this.u1o_1.toLocalDate());
      }
      w1w() {
        return LocalTime().h27(this.u1o_1.toLocalTime());
      }
      equals(other) {
        var tmp;
        if (this === other) {
          tmp = true;
        } else {
          var tmp_0;
          if (other instanceof LocalDateTime_0()) {
            tmp_0 = this.u1o_1 === other.u1o_1 || this.u1o_1.equals(other.u1o_1);
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        }
        return tmp;
      }
      hashCode() {
        return this.u1o_1.hashCode();
      }
      toString() {
        return this.u1o_1.toString();
      }
      i27(other) {
        return this.u1o_1.compareTo(other.u1o_1);
      }
      d(other) {
        return this.i27(other instanceof LocalDateTime_0() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'LocalDateTime', VOID, VOID, [Comparable()], VOID, VOID, {0: LocalDateTimeIso8601Serializer_getInstance});
    LocalDateTimeClass = $;
  }
  return LocalDateTimeClass;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance2vzevs5m6d283,
  LocalDateTime_0 as LocalDateTime3vqv9moe7clf4,
  format as format3s5sut20n6a4c,
};
//endregion

//# sourceMappingURL=LocalDateTime.mjs.map
